export default function Footer() {
  return (
    <footer className="bg-yellow-50 py-8">
      <div className="max-w-md mx-auto px-4">
        <div className="flex items-center gap-2 mb-4 bg-orange-500 px-3 py-2 rounded-lg">
          <img
            src="https://static.readdy.ai/image/d50572b1dfc4f7f997ef99fe23e21a49/b232d040de61573eedf12b26b009967a.png"
            alt="ねこのせなか整体院"
            className="h-10 w-auto object-contain"
            style={{ maxWidth: '120px' }}
          />
          <div>
            <h3 className="text-sm font-bold text-white">ねこのせなか整体院</h3>
          </div>
        </div>

        <div className="space-y-1 text-gray-600 text-xs mb-4">
          <p>営業時間：10:00〜21:00（年中無休）</p>
          <p className="text-gray-500">※研修などで不定期にお休みをいただく場合があります</p>
          <p>〒277-0005 千葉県柏市柏3‐5‐14 永江ビル102</p>
          <p>柏駅東口より徒歩7分</p>
          <a href="tel:04-7197-2992" className="hover:text-orange-500 transition-colors cursor-pointer block">
            TEL：04-7197-2992
          </a>
        </div>

        <div className="border-t border-yellow-200 pt-4 flex flex-col items-center gap-2">
          <p className="text-gray-500 text-xs">
            &copy; 2025 ねこのせなか整体院. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-gray-400 hover:text-orange-500 transition-colors text-xs cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
